export default {
  methods: {
    usersToSelectItem(users) {
      if (users !== undefined) {
        return users.map(({ name, uid }) => ({
          text: name,
          value: uid,
        }));
      }
      return [];
    },
  },
};
